<div class="fizz-flex-item fizz-stack-16" data-testid="no_payment_method_banner">
  <div class="fizz-alert-info">
    <p><strong>No Payment Method on file</strong></p>
    <p class="fizz-text-medium fizz-stack-4">
      Your payment method has been removed from your account. To continue, please add a payment
      method below.
    </p>
  </div>
</div>
